<span class="mr-3 h-11 w-11 flex items-center justify-center rounded-full text-white font-medium uppercase text-sm"
  [ngStyle]="{ 'background-color': avatarColor }">
  {{ userInitials() }}
</span>